export const NOTIFICATION_MESSAGE = 'notificationMessage'
export const LENDING_MESSAGE = 'lendingMessage'
export const SPECIAL_MESSAGE = 'specialRace'
export const GUILD_MESSAGE = 'guild'
export const ITEMS_MESSAGE = 'items'
export const PROFILE_MESSAGE = 'profile'
